import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';

import { Link } from '@confluence/route-manager/entry-points/Link.ts';

import { i18n } from '../changeHistoryMacroI18n.ts';
import type { ChangeHistoryVersion } from '../changeHistoryMacroTypes.ts';

export type VersionLinkProps = {
	version: ChangeHistoryVersion;
	href: string;
	isCurrent: boolean;
};

const styles = cssMap({
	versionCell: {
		paddingInlineStart: token('space.100'),
	},
});

export const VersionLink = ({ version, href, isCurrent }: VersionLinkProps): React.JSX.Element => {
	const content = isCurrent ? (
		<FormattedMessage
			{...i18n.currentVersionWithNumber}
			values={{ versionNumber: version.number }}
		/>
	) : (
		<FormattedMessage {...i18n.versionWithNumber} values={{ versionNumber: version.number }} />
	);

	return (
		<Box xcss={styles.versionCell}>
			{isCurrent ? (
				<Text as="strong">
					<Link href={href}>{content}</Link>
				</Text>
			) : (
				<Text>
					<Link href={href}>{content}</Link>
				</Text>
			)}
		</Box>
	);
};
